export default __webpack_public_path__ + "static/article-insider-tips-for-wedding-planning-a737ebb2d00669065a255d76eeb5d923.jpg";